import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-project-stretch-goal-grid"
}
const _hoisted_2 = {
  key: 1,
  class: "gfu-project-stretch-goal-placeholder"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_stretch_goal_card = _resolveComponent("project-stretch-goal-card")

  return ($props.stretchGoals.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.stretchGoals, (stretchGoal) => {
          return (_openBlock(), _createBlock(_component_project_stretch_goal_card, {
            key: stretchGoal.projectStretchGoalID,
            class: "gfu-project-stretch-goal-grid__item",
            "stretch-goal": stretchGoal,
            "currency-symbol": $props.currencySymbol,
            "data-qa": `project-stretch-goals-card:${stretchGoal.projectStretchGoalID}`
          }, null, 8 /* PROPS */, ["stretch-goal", "currency-symbol", "data-qa"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString($props.placeholderText), 1 /* TEXT */)
      ]))
}